/** Singleton OktaAuth instance shared across the app. */
import { OktaAuth } from '@okta/okta-auth-js';

import { oktaConfig } from './oktaConfig';

let instance: OktaAuth | null = null;

export const getOktaAuth = (): OktaAuth => {
    if (!instance) {
        instance = new OktaAuth(oktaConfig);
    }
    return instance;
};

export const oktaSignOut = async (): Promise<void> => {
    try {
        await getOktaAuth().signOut();
    } catch {
        // App proceeds to clear local state and redirect to /login.
    }
};

/**
 * Reads the refresh token issued by Okta. Used ONCE at login to hand the token
 * to the app (sessionStorage). After that, the app owns and rotates it via
 * /api/security/okta/refresh and never reads from or writes to Okta again.
 */
export const getOktaRefreshToken = async (): Promise<string> => {
    try {
        const tokens = await getOktaAuth().tokenManager.getTokens();
        return tokens.refreshToken?.refreshToken ?? '';
    } catch {
        return '';
    }
};

export const getOktaAccessToken = async (): Promise<string> => {
    try {
        const tokens = await getOktaAuth().tokenManager.getTokens();
        return tokens.accessToken?.accessToken ?? '';
    } catch {
        return '';
    }
};
